import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { tareaService } from '../services/tareaService';

/** Lo que el Examen de Título espera del usuario: crear la agenda, responder en Miti, elegir el horario o agendar. */
export const TIPOS_EXAMEN = ['coordinar_examen', 'disponibilidad_examen', 'elegir_horario', 'agendar_examen'];

/**
 * Las tareas del examen. Los correos de coordinación pueden no llegar: esto las deja a la
 * vista en «Mis Procesos» y en el contador de la barra lateral.
 */
export function useTareasExamen() {
  const { data } = useQuery({ queryKey: ['tareas'], queryFn: tareaService.lista, refetchInterval: 5 * 60_000 });
  return (data ?? []).filter((t) => TIPOS_EXAMEN.includes(t.tipo));
}

export function useNotificacion() {
  return useQuery({ queryKey: ['notificacion'], queryFn: tareaService.notificacion });
}

export function useSetFrecuencia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (frecuencia: string) => tareaService.setFrecuencia(frecuencia),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notificacion'] }),
  });
}
